import AppStoreContext from 'contexts/AppStoreContext';
import React, { useContext, useEffect } from 'react';
import { useTranslator } from '@bluebeam/react-i18n';
import FileManagerCounters from './FileManagerCounters';
import FileManagerRow from './FileManagerRow';

const UploadTab: React.FC = () => {
  const { actions, state } = useContext(AppStoreContext);
  const { translate } = useTranslator(['fileManagerModalFC']);
  const intervalId = 0;

  useEffect(() => {
    window.setInterval(() => {
      actions.getRecentUploads();
    }, 5000);
    return () => {
      window.clearInterval(intervalId);
    };
  }, []);

  const { recentUploads, activeUploads } = state;
  const { processingStatuses } = state;
  const { addCancelationRequest } = actions;

  const activeProcessingRequestIds = Array.from(processingStatuses.values())
    .filter((p) => p.status === 'Processing')
    .map((p) => p.processingRequestid);

  const nonUploadingProcessingRequestIds = Array.from(
    processingStatuses.values()
  )
    .filter((p) => p.status !== 'Uploading')
    .map((p) => p.processingRequestid);

  const uploadingProcessingRequestIds = Array.from(processingStatuses.values())
    .filter((p) => p.status === 'Uploading')
    .map((p) => p.processingRequestid);

  const recentUploadValues = Array.from(recentUploads.values()).filter(
    (ruv) => !uploadingProcessingRequestIds.includes(ruv.processingRequestId)
  );
  const activeUploadsValues = Array.from(activeUploads.values()).filter(
    (auv) => !nonUploadingProcessingRequestIds.includes(auv.processingRequestId)
  );

  const allUploads = activeUploadsValues
    .flatMap((au) => au.documentsProgress)
    .concat(recentUploadValues.flatMap((ru) => ru.documentsProgress))
    .sort((a, b) => {
      if (a.error !== '' && b.error === '') return -1;
      if (a.error === '' && b.error !== '') return 1;
      if (a.timestamp < b.timestamp) return -1;
      if (a.timestamp > b.timestamp) return 1;
      return 0;
    });

  const allUploadCount = allUploads.length;
  const errorCount = allUploads.filter((u) => u.error && u.error !== '').length;

  const inProgress = recentUploadValues.filter((ruv) =>
    activeProcessingRequestIds.find((f) => f === ruv.processingRequestId)
  );

  return (
    <div id="file-manager-modal-upload-tab" className="oh column w100 h100">
      <FileManagerCounters
        label={translate('fileManagerModalFC:uploads')}
        allCount={allUploadCount}
        errorCount={errorCount}
        inProgressCount={inProgress.length}
      />
      <div
        className="mr5 ml5 column bgd-gray-2 font-size-4 medium"
        style={{
          flex: '5  5 100%',
          overflowY: 'auto',
          borderTopLeftRadius: '8px',
          borderTopRightRadius: '8px',
          border: 'solid 0.5px #dcdfe3',
          borderBottomColor: 'transparent',
          color: '#363d43',
        }}
      >
        {allUploads.map((d) => (
          <FileManagerRow
            type="Upload"
            key={d.id}
            label={d.title}
            percentComplete={
              d.totalUploaded !== d.totalToUpload
                ? (d.totalUploaded / d.totalToUpload) * 100
                : 100
            }
            error={!!(d.error && d.error.length > 0)}
            id={d.id}
            onCancel={async (docID) => {
              await addCancelationRequest(docID);
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default UploadTab;
